
// # joint-ird
export enum TaxRegistrationStatus {
    ENABLED = 1,
    REQUIRED = 2,
    NOT_APPLICABLE = 3
}

export enum EntityLegalType {
    Individual = 10,
    Joint = 15,
    Trust = 20,
    Estate = 25,
    Company = 30,
    Partnership = 40,
    UnitTrust = 50,
    MutualFund = 55,
    LLP = 60,
    PIP = 70,
    IncorporatedSociety = 80
}

export interface EntityTaxVM {
    taxNumber: string;
    userEntityId: string;
}

export interface AdvisorInformation {
    name: string;
    email: string;
    phoneNumber: string;
    relatedInvestorEntityId: number;
    relatedInvestorEntityName: string;
}